import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ ext, handleCancelClick, increment, setExtId }) => {
  const [newExt, setNewExt] = useState(ext);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(false);
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewExt((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "extention/" + newExt.id + "/",
          newExt,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    saveData();
    setExtId(null);
    setError(false);
  };

  return (
    <tr>
      <td>{ext.id}</td>
      <td>{ext.previous_date}</td>
      <td>
        <input
          type="date"
          name="ext_date"
          className="form-control"
          id="ext_date"
          value={newExt.ext_date}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <textarea
          name="notes"
          value={newExt.notes}
          onChange={handleChange}
          className="form-control"
          id="notes"
          placeholder="עדיף לתעד סיבת ההארכה"
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
